import React from 'react';

import {Types} from '@wheeebo/polaris-api';
import NoFlyZoneEditForm from '@components/form/NoFlyZoneEditForm';

interface Props {
  noFlyZoneId: Types.UUID;
}

const NoFlyZoneUpdateForm = ({noFlyZoneId}: Props): JSX.Element => (
  <NoFlyZoneEditForm noFlyZoneId={noFlyZoneId} locked />
);

export default React.memo(NoFlyZoneUpdateForm);
